<template>
  <BaseSimuladorIndicadorModal
    ref="baseModal"
    :modal-id="modalId"
    title="Simulador"
    numerador-label="Numerador"
    denominador-label="Denominador"
    :valor-numerador="nManual"
    :valor-denominador="dManual"
    :base-numerador="baseNumerador"
    :base-denominador="baseDenominador"
    :procedimentos-numerador="PROCEDIMENTOS_NUMERADOR"
    :procedimentos-denominador="PROCEDIMENTOS_DENOMINADOR"
    :tipos="TIPOS_CLASSIFICACAO"
    :calculate-result-fn="calcularResultado"
    :calculate-class-fn="calcularClasse"
    :apply-preset-fn="aplicarPreset"
    :format-delta-fn="formatDelta"
    :result-text-fn="montarTextoResultado"
    hint="💡 Os botões preenchem valores de exemplo. Ajuste manualmente pelos controles acima."
    @update:numerador="setNumerador"
    @update:denominador="setDenominador"
    card="desenvolvimento-infantil"
  />
</template>

<script>
import BaseSimuladorIndicadorModal from '@/pages/IndicadoresAps/components/BaseSimuladorIndicadorModal.vue'

export default {
  name: 'SimuladorModal',
  components: {
    BaseSimuladorIndicadorModal,
  },
  props: {
    modalId: {
      type: String,
      default: 'simulador-modal',
    },
    dadosPercentualMunicipio: {
      type: Object,
      default: () => ({}),
    },
    dadosPercentualEquipe: {
      type: Object,
      default: () => ({}),
    },
    dadosPercentualMicroArea: {
      type: Object,
      default: () => ({}),
    },
    selectedEquipe: {
      type: [Object, String],
      default: '',
    },
    selectedMicroArea: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      nManual: 0,
      dManual: 1,
      baseNumerador: 0,
      baseDenominador: 1,
      TIPOS_CLASSIFICACAO: [
        { value: 'Ótimo', label: 'Ótimo', description: '> 75 e <= 100' },
        { value: 'Bom', label: 'Bom', description: '> 50 e <= 75' },
        {
          value: 'Suficiente',
          label: 'Suficiente',
          description: '> 25 e <= 50',
        },
        { value: 'Regular', label: 'Regular', description: '<= 25' },
      ],
      PROCEDIMENTOS_NUMERADOR: [
        {
          icon: null,
          codigo: null,
          desc: '1ª consulta presencial realizada por médica(o) ou enfermeira(o), até o 30º dia de vida.',
        },
        {
          icon: null,
          codigo: null,
          desc: '09 (nove) consultas presenciais ou remotas realizadas por médica(o) ou enfermeira(o) até dois anos de vida.',
        },
        {
          icon: null,
          codigo: null,
          desc: '09 (nove) registros simultâneos de peso e altura até os dois anos de vida.',
        },
        {
          icon: null,
          codigo: null,
          desc: '02 (duas) visitas domiciliares realizadas por ACS/TACS, sendo a primeira até os primeiros 30 (trinta) dias de vida e a segunda até os 06 (seis) meses de vida.',
        },
        {
          icon: null,
          codigo: null,
          desc: 'Vacinas contra difteria, tétano, coqueluche, hepatite B, infecções causadas por Haemophilus influenzae tipo b, poliomielite, sarampo, caxumba e rubéola, pneumocócica, registradas com todas as doses recomendadas.',
        },
      ],
      PROCEDIMENTOS_DENOMINADOR: [
        {
          icon: null,
          codigo: null,
          desc: 'Total de crianças que completa 2 anos no quadrimestre avaliado.',
        },
      ],
    }
  },
  methods: {
    open() {
      this.aplicarFonte()
      this.$refs.baseModal.open()
    },

    close() {
      this.$refs.baseModal.close()
    },

    aplicarFonte() {
      let fonte = this.dadosPercentualMunicipio

      if (this.selectedMicroArea) {
        fonte = this.dadosPercentualMicroArea
      } else if (this.selectedEquipe) {
        fonte = this.dadosPercentualEquipe
      }

      const numerador = Number(fonte?.numerador) || 0
      const denominador = Number(fonte?.denominador) || 1

      this.nManual = numerador
      this.dManual = denominador
      this.resetBase()
    },

    setNumerador(valor) {
      this.nManual = valor
    },

    setDenominador(valor) {
      this.dManual = valor
    },

    resetBase() {
      this.baseNumerador = this.nManual
      this.baseDenominador = this.dManual
    },

    calcularResultado({ numerador, denominador }) {
      const d = Number(denominador) || 0
      if (d <= 0) return 0

      const n = Number(numerador) || 0
      return Number((n / d).toFixed(2))
    },

    calcularClasse({ resultado }) {
      if (resultado > 100) {
        return { nivel: 'Ótimo', variant: 'primary' }
      }
      if (resultado > 75 && resultado <= 100) {
        return { nivel: 'Ótimo', variant: 'primary' }
      }
      if (resultado > 50 && resultado <= 75) {
        return { nivel: 'Bom', variant: 'success' }
      }
      if (resultado > 25 && resultado <= 50) {
        return { nivel: 'Suficiente', variant: 'warning' }
      }
      if (resultado <= 25) return { nivel: 'Regular', variant: 'danger' }

      return { nivel: 'Regular', variant: 'danger' }
    },

    aplicarPreset({ tipo, setNumerador, setDenominador }) {
      if (tipo === 'Ótimo') {
        setNumerador(7501)
        setDenominador(100)
      } else if (tipo === 'Bom') {
        setNumerador(5001)
        setDenominador(100)
      } else if (tipo === 'Suficiente') {
        setNumerador(2501)
        setDenominador(100)
      } else {
        setNumerador(2500)
        setDenominador(100)
      }

      this.$nextTick(() => {
        this.resetBase()
      })
    },

    formatDelta(val) {
      if (val > 0) return `+${val}`
      if (val < 0) return `${val}`
      return ''
    },

    montarTextoResultado({ resultado }) {
      return ``
    },
  },
}
</script>
